import * as React from 'react';
import { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { IQRScanResult, IQRScanAdminRequest, IEquipmentManifest } from '../_types/location';
import { TestRemoteStart as runTest } from '../_service/location';
import { ServerTestMode } from '../_service/auth';

import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
    /** the item to display */
    equipment_id: string | null,
    service_plan_uuid: string;
    service_location_uuid: string ;
    manifest: IEquipmentManifest;

};

// LEARN
// const useStyles = makeStyles((theme) => ({
//     formControl: {
//         margin: theme.spacing(1),
//         minWidth: 120,
//         }
// //     home: { color: "primary" },
// //     away: { color: theme.palette.grey[900] }
// }));

const TestRemoteStart: React.FC<Props> = (prop: Props) => {

    const [show, setShow] = useState<boolean>(false);
    const [lastResult, setLastResult] = useState<IQRScanResult | null>(null);
    const [svrTestMode, setSvrTestMode] = useState<boolean>(false);
    
    React.useEffect(() => {
        ServerTestMode().then(result => {
            setSvrTestMode(result);
        })
    }, [])

    const _locationName = (): string => {
        let loc = prop.manifest.plans.find(g => g.service_plan_uuid === prop.service_plan_uuid);
        let toReturn = "errr";
        if (loc) {
            toReturn = loc.location_name;
        }
        return toReturn;
    }

    const _testMode = ():boolean => {
        let svr = svrTestMode;
        let client = process.env.REACT_APP_TEST_MODE !== "live";

        return svr || client;
    }

    const _planName = (): string => {
        let loc = prop.manifest.plans.find(g => g.service_plan_uuid === prop.service_plan_uuid);
        let toReturn = "errr";
        if (loc) {
            toReturn = loc.service_plan_name;
        }
        return toReturn;
    }

    const _startWash = () => {
        if (prop.equipment_id) {
            let config: IQRScanAdminRequest = {
                equipment_id: prop.equipment_id,
                service_location_id: prop.service_location_uuid,
                service_plan_id: prop.service_plan_uuid
            };
            let providerName = prop.manifest.interfaces.find(remoteInterface =>
                !remoteInterface.deleted && remoteInterface.equipment.some(equipment =>
                    equipment.qrcode === prop.equipment_id
                )
            )?.provider_name;

            runTest(config, providerName).then(result => { setLastResult(result) });

        } else {
            setLastResult({
                one_time_use_code: null,
                remote_start: {
                    instructions: "Nothing happened"
                }
            });
        }
    }

    return (
        <React.Fragment>
        <Button onClick={() => setShow(true)}>Test</Button>
        {show && (
        <Dialog scroll="paper" open={true}>
            <DialogTitle>Test Remote Start</DialogTitle>
            
            <DialogContent>
                <DialogContentText>
                {!_testMode() ? (
                <Typography>
                This will start the wash at {_locationName()} for service plan {_planName()}.  Please make sure you are coordinating with someone at the location before proceeding. 
                </Typography>
                ): (
                    <Typography>
                    This will SIMULATE starting the wash at {_locationName()} for service plan {_planName()}.  This does not actually start the wash!
                    </Typography>
                )
                }
                </DialogContentText>
            <Grid container direction="column" alignItems="flex-start">

                <Grid item>
                    <Button onClick={() => _startWash()}>Start Wash</Button>
                </Grid>

                { lastResult && (
                    <Grid item>
                        {lastResult.remote_start?.instructions}
                    </Grid>
                )}
            </Grid>
            </DialogContent>
            <DialogActions>
     
                            <Button onClick={() => setShow(false)}>Close</Button>

                       
                       
            </DialogActions>
            </Dialog> )}
        </React.Fragment>
    )
}

export default TestRemoteStart;
